import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import Navbar from "./components/common/Navbar";
import RestaurantMaster from "./components/pages/restaurant/RestaurantMaster";
import CuisineMaster from "./components/pages/cuisine/CuisineMaster";
import ItemMaster from "./components/pages/item/ItemMaster";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import RestuaurantEmployeeMaster from "components/pages/restaurant/employee/RestuaurantEmployeeMaster";
import IngredientMaster from "components/pages/ingredient/IngredientMaster";
import UserAdminMaster from "components/pages/user/admin/UserAdminMaster";
import BrandMaster from "components/pages/brand/BrandMaster";
import UnitOfMeasurementMaster from "components/pages/unitOfMeasurement/UnitOfMeasurementMaster";
import AppRoutes from "AppRoutes";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster
        toastOptions={{
          duration: 2000,
          // style: toastDefaultOptionsStyle,
        }}
      />
    </>
  );
}

export default App;
